import React from 'react'

export default function SurchargesInfoHeader() {
  return (
    <div className="parameters-page__global-rule">
      <span role="img" aria-label="shield">🛡️</span>
      <span className="parameters-page__global-rule-title">Regla global por defecto:</span>
      <span className="parameters-page__global-rule-text">Todos los canales aplican recargos y descuentos. Las reglas de abajo son EXCEPCIONES.</span>
    </div>
  )
}
